import { trpc } from '@/lib/api/trpc';
import { usePrivilegedStaffBypass } from '@/hooks/use-privileged-staff-bypass';
import { isNoAccountLinked } from '@/lib/trpc-error-utils';

export type RestrictionReason = 'unpaid_invoice' | 'compliance_review' | 'account_suspended' | null;

export function useAccountRestrictions() {
    const { data: userInfo, isLoading, error } = trpc.users.getCurrentUserInfo.useQuery(
        {},
        {
            staleTime: 5 * 60 * 1000,
            gcTime: 10 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
        }
    );

    const { canBypass: isBypassed } = usePrivilegedStaffBypass();

    const restrictions = userInfo?.accountRestrictions;

    const getRestrictionReason = (): RestrictionReason => {
        if (!restrictions || isBypassed) return null;

        if (restrictions.blockAccessUntilPaid) return 'unpaid_invoice';
        if (restrictions.suspended) return 'account_suspended';
        if (restrictions.manualReviewRequired) return 'compliance_review';

        return null;
    };

    const restrictionReason = getRestrictionReason();

    return {
        showWarningBanner: !isBypassed && (restrictions?.accountBlockWarning === true),
        hasAccessRestriction: restrictionReason !== null,
        restrictionReason,
        noAccountLinked: isNoAccountLinked(error),
        isLoading,
    };
}
